<script setup lang="ts">
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

import { UserRoundPlus } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import DialogAddMember from './DialogAddMember.vue'
import MembersList from './MembersList.vue'
import InvitesList from './InvitesList.vue'

const store = useStore()
const route = useRoute()

const mapId = computed(() => route.params.map_id as string)
const orgId = computed(() => store.getters['org/getSelected'])
const map = computed(() => store.getters['maps/getMapById'](orgId.value, mapId.value))
const members = computed(() => store.getters['maps/getMapMembers'](mapId.value))
const invites = computed(() => store.getters['maps/getMapInvites'](mapId.value))
const pendingInvites = computed(() => invites.value.filter((i: any) => !i.is_accepted))

watch(
  [orgId, mapId],
  ([org, map]) => {
    if (!org || !map) return
    store.dispatch('maps/fetchMapMembers', { orgId: org, mapId: map })
    store.dispatch('maps/fetchMapInvites', { orgId: org, mapId: map })
  },
  { immediate: true }
)
</script>

<template>
  <div class="px-3 py-2" data-testid="map-members-page">
    <div class="mb-4">
      <h2 class="text-lg font-semibold">{{ map?.name || 'Map' }} — Members</h2>
      <p class="text-sm text-muted-foreground">People with access to this map.</p>
    </div>

    <div class="mb-1 flex items-center justify-between">
      <h3 class="text-base font-bold">Members ({{ members.length }})</h3>
      <DialogAddMember>
        <Button variant="ghost" size="sm" class="px-2">
          <UserRoundPlus class="w-4 h-4 mr-1" />
          Add
        </Button>
      </DialogAddMember>
    </div>

    <MembersList :members="members" :map-id="mapId" />

    <div class="mt-6 mb-2">
      <h3 class="text-base font-bold">Pending invites ({{ pendingInvites.length }})</h3>
    </div>
    <InvitesList v-if="pendingInvites.length" :invites="pendingInvites" :map-id="mapId" />
    <p v-else class="text-sm text-muted-foreground">No pending invites.</p>
  </div>
</template>
